import type en from './en';

const it: typeof en = {
  chatMeeting: {
    prompt: '{{name}} ha chiesto di incontrarvi. Accetti?',
    yes: 'Sì, proponi orari',
    decline: 'Rifiuta',
    notInterested: 'Non mi interessa',
    error: 'Non è stato possibile salvare. Riprova.',
  },
  join: {
    title: 'Hai accesso a una Segretaria IA',
    titleThanks: '(grazie a {{name}})',
    scanQr:
      'Scansiona il codice QR con il telefono per avviare una conversazione WhatsApp con la tua nuova segretaria.',
    fromThere:
      'Da lì potrai configurare il tuo account e lasciare che la tua segretaria si occupi delle tue incombenze!',
    openWhatsApp: 'Apri WhatsApp',
    inviteOnlyTitle: 'Al momento Dream è solo su invito.',
    invalidBody:
      'Questo link di invito non è valido: potrebbe essere stato digitato male o non essere più attivo. Chiedi un nuovo link alla persona che ti ha invitato, oppure iscriviti alla nostra lista d’attesa e ti ricontatteremo.',
    joinWaitlist: 'Iscriviti alla lista d’attesa',
    loading: 'Caricamento',
  },
  connect: {
    statusAlreadyConnected:
      'Questo account è già collegato. Puoi aggiungerne un altro qui sotto.',
    statusExpired:
      'Questo link è scaduto. Chiedi alla tua segretaria di inviartene uno nuovo.',
    statusInvalidToken:
      'Questo link non è valido. Chiedi alla tua segretaria di inviartene uno nuovo.',
    statusAlreadyLinkedOther:
      'Quell’account è già collegato a un altro account Dream.',
    statusError:
      'Non siamo riusciti a caricare la pagina di collegamento. Riprova.',
    missingToken:
      'Token di onboarding mancante. Apri questa pagina da WhatsApp.',
    loadAccountsError:
      'Al momento non è possibile caricare gli account collegati.',
    disconnectError: 'Impossibile scollegare questo account.',
    yourAccount: 'Il tuo account',
    title: 'Collega il tuo account',
    body1:
      'Collega email e calendario così la tua segretaria potrà seguire le tue attività e tenere d’occhio sovrapposizioni e conflitti in agenda.',
    body2: 'Non invierà mai un’email dal tuo account.',
    allDone: 'Fatto?',
    youCan: 'Puoi',
    returnToWhatsApp: 'tornare su WhatsApp',
    keepConnecting: ' oppure continuare a collegare account',
    loadingAccounts: 'Caricamento degli account collegati…',
    connectedAccount: 'Account collegato',
    disconnectAria: 'Scollega {{account}}',
    thisAccount: 'questo account',
    connectGoogle: 'Collega il tuo account Google',
    connectAnotherGoogle: 'Collega un altro account Google',
    connectOutlook: 'Collega il tuo account Outlook',
    connectAnotherOutlook: 'Collega un altro account Outlook',
    disclaimer: 'Supportiamo account Gmail, Google Workspace e Outlook.',
  },
  travelOptions: {
    title: 'Opzioni di viaggio',
    eyebrow: 'Il tuo viaggio',
    tabs: 'Opzioni di viaggio',
    flights: 'Voli',
    hotels: 'Alloggi',
    trains: 'Treni',
    flight: 'Volo',
    hotel: 'Alloggio',
    train: 'Treno',
    removeTask: 'Rimuovi attività',
    book: 'Prenota',
    bookWithDream: 'Prenota con Dream',
    separateTickets: 'Biglietti separati',
    separateTicketsWarning:
      'Questi voli vengono prenotati separatamente. Controlla il tempo di coincidenza e considera eventuali ritardi.',
    seeReturnTimes: 'Vedi gli orari di ritorno',
    otherReturnTimes: 'Altri orari di ritorno ({{count}})',
    bookBothFlights: 'Prenota entrambi i voli',
    viewStay: 'Vedi alloggio',
    loading: 'Caricamento delle opzioni di viaggio…',
    close: 'Chiudi',
    outbound: 'Andata',
    return: 'Ritorno',
    returnsErrorTitle: 'Non siamo riusciti a caricare i tuoi voli di ritorno',
    returnsErrorBody: 'Riprova o torna indietro per vedere altre opzioni',
    returnsRateLimited:
      'Troppe richieste su questa pagina. Attendi qualche minuto.',
    tryAgain: 'Riprova',
    back: 'Indietro',
    returnRefreshCountdown: 'I prezzi si aggiorneranno tra {{time}}',
    flightUnavailable: 'Questo volo non è più disponibile. Scegline un altro.',
    gettingLivePricesButton: 'Recupero dei prezzi aggiornati…',
    flightBookingPending:
      'Sto prenotando {{time}} per {{place}}. Ti farò sapere quando sarà fatto.',
    flightBookingConfirmed:
      'Ho prenotato {{time}} per {{place}} il {{date}}.{{reference}}',
    flightBookingUnknown:
      'Sto verificando se {{time}} per {{place}} è andato a buon fine. Ti farò sapere.',
    flightBookingNotBooked:
      'Non ho potuto prenotare {{time}} per {{place}}. Ti scriverò per dirti cosa fare dopo.',
    hotelBookingPending:
      'Sto prenotando {{name}}. Ti farò sapere quando sarà fatto.',
    hotelBookingConfirmed: 'Ho prenotato {{name}}.{{reference}}',
    hotelBookingUnknown:
      'Sto verificando se {{name}} è andato a buon fine. Ti farò sapere.',
    hotelBookingNotBooked:
      'Non ho potuto prenotare {{name}}. Ti scriverò per dirti cosa fare dopo.',
    sameTicket: 'Stesso biglietto',
    confirmBooking: 'Conferma prenotazione',
    traveller: 'Viaggiatore',
    sort: {
      label: 'Ordina per',
      recommended: 'Consigliato',
      price: 'Prezzo',
      departure: 'Orario di partenza',
      arrival: 'Orario di arrivo',
      duration: 'Durata',
      rating: 'Valutazione',
    },
  },
  suggestions: {
    loading: 'Caricamento…',
    linkExpiredTitle: 'Link scaduto',
    somethingOffTitle: 'Qualcosa non va',
    expiredBody:
      'Questo link è scaduto. Chiedi alla tua segretaria su WhatsApp e te ne invierà uno nuovo.',
    invalidBody:
      'Questo link non è valido. Apri il link dalla tua conversazione WhatsApp.',
    errorBody:
      'Si è verificato un problema nel caricare questa pagina. Riprova tra un attimo.',
    fromAssistantNamed: 'Da {{name}}, la tua segretaria',
    fromAssistant: 'Dalla tua segretaria',
    titleLead: 'Si',
    titleAccent: 'comincia',
    coverCopy:
      'Sei cose che gli altri mi affidano ogni settimana — esempi veri, di utenti veri. Scegline una e al resto penso io.',
    swipeUp: 'Scorri verso l’alto',
    picked: 'Scelta — ti farò sapere',
    swipeNext: 'Scorri per la prossima',
    thatsTheLot: 'È tutto — scegline una ✦',
  },
  tour: {
    carouselAria: 'Le novità di Dream',
    whatsNew: 'Novità',
    ofCount: '{{n}} di {{total}}',
    previous: 'Indietro',
    startExploring: 'Inizia a esplorare',
    showMeAfter: 'Mostramelo dopo',
    addedAfterList: 'Perfetto, te ne parlerò',
    addedForWhatsApp: 'Aggiunto — te ne parlo su WhatsApp',
    added: 'Aggiunto',
    notInterested: 'Non mi interessa',
    okThanks: 'Ok, grazie',
    doneTitle: 'Ci vediamo su WhatsApp',
    doneBody:
      'Riprenderò nella nostra chat tutto quello che ti ha incuriosito. Puoi chiudere questa pagina.',
    openWhatsApp: 'Torna su WhatsApp',
    linkExpiredTitle: 'Questo link è scaduto',
    somethingOffTitle: 'Qualcosa non va',
    expiredBody:
      'Questo link non è più attivo. Scrivi alla tua segretaria su WhatsApp e chiedile delle novità.',
    invalidBody:
      'Questo link non è valido. Apri il link dalla tua conversazione WhatsApp.',
    errorBody: 'Qualcosa è andato storto. Riprova tra un momento.',
    scenes: {
      summary: {
        name: 'Riepilogo',
        headline: 'Ecco le novità',
        tail: 'per ora.',
        line: 'Quello che è spuntato lo riprendo con te su WhatsApp.',
      },
      intro: {
        name: 'Introduzione',
        headline: '{{name}} ha',
        tail: 'qualche nuova abilità.',
        line: 'Ecco {{count}} novità di {{name}} da provare.',
      },
      scheduling: {
        name: 'Appuntamenti',
        headline: 'Mai più a rincorrere',
        tail: 'un orario per vedersi.',
        line: 'Dimmi chi devi incontrare e più o meno quando. Concordo un orario con loro e lo metto nel tuo calendario.',
        topic: 'fissare riunioni',
      },
      assistants: {
        name: 'Da segretaria a segretaria',
        headline: 'Riunioni con i colleghi,',
        tail: 'concordate tra segretarie.',
        line: 'Se anche loro usano Dream, le nostre segretarie si mettono d’accordo sull’orario tra loro. Si condivide solo la pianificazione, nient’altro del tuo calendario.',
        topic: 'parlare con le segretarie degli altri',
      },
      shop: {
        name: 'Spesa settimanale',
        headline: 'La tua spesa Ocado,',
        tail: 'pianificata e nel carrello.',
        line: 'Collega Ocado e raccontami com’è la settimana. Pianifico i pasti, riempio il carrello e verifico con te prima di confermare.',
        topic: 'la tua spesa settimanale su Ocado',
      },
      email: {
        name: 'Email su WhatsApp',
        headline: 'Rispondi alle email',
        tail: 'senza aprirle.',
        line: 'Preparo le risposte con il tuo tono e te le mostro qui. Tocca Invia, oppure apri la bozza per modificarla prima.',
        topic: 'rispondere alle email da WhatsApp',
      },
      check_in: {
        name: 'Punto della sera',
        headline: 'Un breve punto',
        tail: 'alle 19.',
        line: 'Cosa è stato fatto oggi, cosa resta aperto e come si presenta domani, così nulla sfugge da un giorno all’altro.',
        topic: 'il punto delle 19',
      },
      organisations: {
        name: 'Organizzazioni',
        headline: 'Porta Dream',
        tail: 'nella tua azienda.',
        line: 'Configura Dream per tutto il tuo team. Aggiungi segretarie per le persone chiave, tutto addebitato su un’unica carta, e li aiuto io a partire.',
        topic: 'Dream per la tua organizzazione',
      },
    },
  },
  briefing: {
    linkExpiredTitle: 'Questa lista è chiusa',
    somethingOffTitle: 'Qualcosa non va',
    expiredBody:
      'Questa Morning List è di un giorno precedente. Ciò che resta aperto tornerà — oppure scrivi alla tua segretaria su WhatsApp.',
    invalidBody:
      'Questo link non è valido. Apri il link dalla tua conversazione WhatsApp.',
    errorBody: 'Qualcosa è andato storto. Riprova tra un momento.',
    brandAria: 'Dream',
    listAria: 'Il tuo briefing',
    navAria: 'Navigazione del briefing',
    optionsAria: 'Azioni per questo elemento',
    chooseAnother: 'Scegli un’altra azione',
    openDraft: 'Apri la bozza',
    copyDraft: 'Copia bozza',
    copied: 'Copiato',
    openLinkedin: 'Apri in LinkedIn',
    openWhatsapp: 'Apri WhatsApp',
    draftOnMac: 'Anche in WhatsApp sul tuo Mac',
    notRelevant: 'Non rilevante',
    notRelevantAria: 'Questo non è rilevante',
    chosen: 'Scelto: {{label}}',
    next: 'Avanti',
    seeList: 'Vedi la tua lista di cose da fare',
    previous: 'Elemento precedente',
    whyPrompt:
      'Hai già saltato cose come “{{headline}}”. Una parola sul perché mi aiuta a non riproporle.',
    whyPlaceholder: 'Perché non è rilevante?',
    whySkip: 'Salta',
    whySend: 'Invia',
    whyThanks: 'Grazie — annotato.',
    todosAria: 'Le tue cose da fare',
    today: 'Oggi',
    tomorrow: 'Domani',
    weekAria: 'Scegli un giorno',
    nothingPlanned: 'Niente in programma.',
    clearDay: 'Giornata libera.',
    clearDayName: 'Giornata libera, {{name}}.',
    nothingDueToday: 'Niente in scadenza oggi.',
    getAhead: 'Portati avanti',
    noDate: 'Senza data',
    doToday: 'Fallo oggi',
    doTodayAria: 'Fai {{title}} oggi',
    spottedInEmail: 'Trovato nelle tue e-mail',
    spottedCount_one: '{{count}} cosa che potresti voler aggiungere',
    spottedCount_other: '{{count}} cose che potresti voler aggiungere',
    sinceDay: 'da {{day}}',
    dueToday: 'Entro oggi',
    dueTomorrow: 'Entro domani',
    dueOn: 'Entro il {{date}}',
    addToToday: 'Aggiungi a oggi',
    addToTomorrow: 'Aggiungi a domani',
    addFor: 'Aggiungi per il {{date}}',
    addToCalendar: 'Aggiungi al calendario',
    addedToTomorrow: 'Aggiunto a domani.',
    addedFor: 'Aggiunto per il {{date}}.',
    addedToCalendar: 'Aggiunto al tuo calendario.',
    addedToCalendarAt: 'Nel tuo calendario: {{date}}, {{time}}.',
    notNow: 'Non ora',
    doneAria: 'Segna {{title}} come fatto',
    actionsFor: 'Azioni per {{title}}',
    delegate: 'Delega',
    findTime: 'Trova tempo',
    assistantFallback: 'Dream',
    notePlaceholder: 'Qualche indicazione?',
    noteAria: 'Nota per {{name}} su {{title}}',
    delegateSend: 'Affida a {{name}}',
    pickHint: 'Tocca un’attività per affidarla o trovarle tempo',
    pickedFor: 'Per: {{title}}',
    recordVoiceNote: 'Registra una nota vocale',
    stopRecording: 'Ferma la registrazione',
    listening: 'Ti ascolto…',
    transcribing: 'Prendo nota…',
    delegationQueued: 'In coda per {{name}}',
    delegationWorking: '{{name}} ci sta lavorando',
    micUnavailable: 'Il microfono non è disponibile qui.',
    lookingForTime: 'Guardo la tua giornata…',
    howAbout: 'Che ne dici delle {{time}}?',
    howAboutContext: 'Che ne dici delle {{time}}, {{context}}?',
    bookIt: 'Prenota',
    otherTimes: 'Altri orari',
    partMorning: 'Mattina',
    partAfterLunch: 'Dopo pranzo',
    partAfternoon: 'Pomeriggio',
    partEndOfDay: 'Fine giornata',
    booked: 'Prenotato alle {{time}} nel tuo calendario.',
    noCalendar: 'Nessun calendario collegato, quindi non c’è dove prenotare.',
    noFreeTime: 'Non c’è più tempo libero oggi.',
    noFreeTimeInPart: 'Non c’è tempo libero in quella parte della giornata.',
    calendarUnavailable: 'Il tuo calendario non è raggiungibile al momento.',
  },
  booking: {
    noKey: 'Nessuna chiave di prenotazione fornita',
    invalidData: 'Dati di prenotazione non validi',
    loadFailed:
      'Impossibile caricare le informazioni di prenotazione. Il link potrebbe essere scaduto o non valido.',
    loading: 'Caricamento delle informazioni di prenotazione...',
    errorTitle: 'Errore nel link di prenotazione',
    goHome: 'Vai alla home',
    noDataTitle: 'Nessun dato di prenotazione',
    noDataBody: 'Impossibile caricare le informazioni di prenotazione.',
    title: 'Completa la prenotazione del volo',
    redirectBody:
      'Stai per essere reindirizzato per completare la prenotazione del volo.',
    provider: 'Fornitore di prenotazione',
    providerFallback: 'Fornitore di prenotazioni voli',
    redirectingIn: 'Reindirizzamento automatico tra {{seconds}} secondi...',
    continueTo: 'Continua su {{provider}}',
    bookingSiteFallback: 'il sito di prenotazione',
    disclaimer:
      'Sarai reindirizzato al sito del fornitore per completare l’acquisto. Questo link è sicuro e scadrà dopo 24 ore.',
  },
  artifact: {
    proofTeamSaw: 'Cosa ha visto il nostro team',
    proofScreenshotOf: 'Screenshot {{n}} di {{total}}',
    proofEmailHeading: 'Email di conferma',
    proofEmailReceived: 'Ricevuta {{when}}',
    proofPrivate: 'Solo chi ha questo link può vedere questa pagina.',
    loading: 'Caricamento...',
    unableToLoad: 'Impossibile caricare',
    noShareToken: 'Nessun token di condivisione fornito',
    loadFailed: 'Impossibile caricare l’elemento',
    gettingLivePrices: 'Recupero dei prezzi aggiornati',
    linkExpired: 'Questo link è scaduto. Chiedine uno nuovo.',
    linkInvalid: 'Questo link non è valido o l’elemento non esiste più.',
    genericError: 'Qualcosa è andato storto. Riprova più tardi.',
    sessionExpired:
      'Questa sessione è scaduta perché non avevi effettuato l’accesso. Chiedi a Dream di inviarti di nuovo il link.',
    linkExpiredShort: 'Questo link è scaduto.',
    alreadyResponded: 'È già stata data una risposta.',
    submitFailed: 'Invio della risposta non riuscito. Riprova.',
    responseSubmitted: 'Risposta inviata',
    responseSubmittedBody:
      'La tua risposta è stata registrata. Puoi chiudere questa pagina.',
    bookingNow: 'Prenotazione in corso',
    bookingNowBody:
      'Un attimo — stiamo prenotando per te. Riceverai la conferma in chat; puoi chiudere questa pagina.',
    booked: 'Prenotato',
    bookedBody:
      'Fatto. La conferma è nella tua chat. Puoi chiudere questa pagina.',
    bookedReference: 'Riferimento {{reference}}',
    notBooked: 'Non prenotato',
    notBookedBody:
      'Non è stato addebitato nulla. Dream è stato informato e ne parlerà con te in chat.',
    bookingUnknown: 'Verifica della prenotazione',
    bookingUnknownBody:
      "La prenotazione non è stata confermata subito. Dream sta verificando con l'operatore e ti aggiornerà in chat — non devi fare altro.",
    paymentReceived: 'Pagamento ricevuto',
    paymentReceivedBody:
      'Stiamo confermando il pagamento: i tuoi crediti saranno aggiunti a breve. Puoi chiudere questa pagina.',
    topUpComplete: 'Ricarica completata',
    topUpCreditsAdded:
      '{{credits}} crediti sono stati aggiunti al tuo account. Puoi chiudere questa pagina.',
    topUpAlreadyDone:
      'Questa ricarica è già stata completata. Puoi chiudere questa pagina.',
    topUpMissingDetails:
      'A questo link di ricarica mancano i dettagli. Chiedine uno nuovo.',
    checkoutFailed: 'Impossibile avviare il pagamento. Riprova.',
    linkExpiredAskDream:
      'Questo link è scaduto. Chiedi a Dream di inviarne uno nuovo.',
    topUpAlreadyCompleted: 'Questa ricarica è già stata completata.',
    topUpFailed: 'Ricarica non riuscita. Nessun addebito sulla tua carta.',
    continueSecureCheckout: 'Continua al pagamento sicuro',
    cardSetupFailed:
      'Impossibile avviare la registrazione della carta. Riprova.',
    cardAdded: 'Carta aggiunta',
    cardAddedBody:
      'La tua carta è salvata. La tua segretaria potrà ricaricarla quando approvi un acquisto. Puoi chiudere questa pagina.',
    subscriptionActive: 'Abbonamento attivo',
    subscriptionActiveBody:
      'Il tuo piano è configurato e i tuoi crediti sono stati aggiunti. Puoi chiudere questa pagina.',
    subscriptionPendingBody:
      'Stiamo confermando il tuo abbonamento: i tuoi crediti saranno aggiunti a breve. Puoi chiudere questa pagina.',
    selectPlan: 'Scegli un piano',
    popular: 'POPOLARE',
    yourPlan: 'Il tuo piano',
    loadingShort: 'Caricamento...',
    choosePlan: 'Scegli {{name}}',
    addCardOnly: 'Oppure aggiungi solo una carta senza piano',
    noContent: 'Nessun contenuto disponibile.',
    alreadyHandled: 'Già gestito',
    alreadyHandledTitled:
      '"{{title}}" ha già ricevuto una risposta, quindi qui non serve fare nulla. Puoi chiudere questa pagina.',
    alreadyHandledUntitled:
      'Questa richiesta ha già ricevuto una risposta, quindi qui non serve fare nulla. Puoi chiudere questa pagina.',
    secureLoginCancelled: 'Accesso annullato',
    secureLoginCancelledLead: 'Accesso',
    secureLoginCancelledAccent: 'annullato',
    secureLoginDone: 'Accesso eseguito',
    secureLoginDoneAccent: 'in sicurezza',
    secureLoginDoneBody:
      'Dream può continuare con il tuo accesso. Puoi chiudere questa pagina.',
    secureCardSaved: 'Carta salvata',
    secureCardSavedAccent: 'in sicurezza',
    secureCardSavedBody:
      'La tua carta è salvata in sicurezza e non viene mai condivisa con la tua segretaria. Puoi chiudere questa pagina.',
    secureLoginCancelledBody:
      'Nessun dato è stato salvato. Puoi chiudere questa pagina e chiedere di nuovo alla tua segretaria quando vuoi.',
  },
  wizard: {
    stepLabelPrivacy: 'La tua privacy',
    mobileStepPrivacy: 'Privacy',
    getStarted: 'Inizia',
    close: 'Chiudi',
    privacyStep: {
      title: 'Delega le seccature, non i tuoi dati',
      lede: 'Una segretaria di alto livello che gestisce la tua giornata e protegge i tuoi dati.',
      point1: 'Non usiamo i tuoi dati per addestrare i nostri modelli',
      point2: 'Non vendiamo mai i tuoi dati a nessuno',
      point3:
        'Quando colleghi un’app, puoi sempre vedere come la usa la tua segretaria',
      point4:
        'Eliminato vuol dire eliminato. Le tue app, il tuo account: se deve sparire, sparisce',
      point5: 'Dream non conserva nessuna email che ricevi',
      learnMore: 'Voglio saperne di più',
      analyticsTitle: 'Aiutaci a migliorare la tua segretaria',
      analyticsBody:
        'Aiutaci a valutare come sta lavorando la tua segretaria. I risultati sono anonimi, nessuno legge le tue conversazioni.',
      modalTitle: 'La tua privacy, spiegata in modo semplice',
      rights: {
        memoryTitle: 'Il diritto di gestire la memoria della tua segretaria',
        memoryBody:
          'Puoi vedere le informazioni importanti che la tua segretaria ricorda su di te. Puoi correggerle o chiederle di cancellarle.',
        conversationTitle: 'Il diritto a una conversazione privata',
        conversationBody:
          'Quello che dici alla tua segretaria resta privato. Condividiamo una conversazione solo se la legge ci obbliga. I tecnici di Dream possono leggere una conversazione solo se hai segnalato un problema, e in quel caso ti avvisiamo.',
        dataUseTitle: 'Il diritto di sapere come usiamo i tuoi dati',
        dataUseBody: 'Non vendiamo i tuoi dati personali.',
        knowTitle: 'Il diritto di sapere cosa sa Dream di te',
        knowBody:
          'Puoi chiederci quali dati abbiamo su di te e ricevere una copia.',
        correctTitle: 'Il diritto di far correggere gli errori',
        correctBody:
          'Se un dato che abbiamo su di te è sbagliato, puoi chiederci di correggerlo.',
        deleteTitle: 'Il diritto di cancellare i tuoi dati',
        deleteBody:
          'Puoi chiederci di cancellare i tuoi dati. Potremmo doverne conservare alcuni se la legge lo richiede.',
        portabilityTitle: 'Il diritto di portare con te i tuoi dati',
        portabilityBody:
          'Puoi chiederci una copia dei tuoi dati in un formato che puoi usare altrove.',
        limitTitle: 'Il diritto di limitare l’uso dei tuoi dati',
        limitBody:
          'Puoi chiederci di smettere di usare i tuoi dati o di usarli meno, finché l’app può continuare a funzionare.',
        accessTitle: 'Il diritto di sapere a cosa accede la tua segretaria',
        accessBody:
          'Puoi vedere a quali account e servizi ha accesso la tua segretaria. Puoi toglierle quell’accesso quando vuoi.',
        providersTitle:
          'Il diritto di sapere chi altro ha bisogno dei tuoi dati',
        providersBody:
          'Dream si affida ad alcuni fornitori di tecnologia. Vengono controllati per verificare che rispettino il GDPR.',
        securityTitle: 'Il diritto a una sicurezza adeguata',
        securityBody:
          'Proteggiamo i tuoi dati e impediamo a chi non è autorizzato di accedervi.',
      },
    },
    stepLabel1: 'Collega i tuoi account',
    stepLabel2: 'Briefing quotidiano',
    stepLabel3: 'Integrazioni',
    stepLabel4: 'La tua segretaria',
    stepLabel5: 'Prime attività',
    mobileStep1: 'Account',
    mobileStep2: 'Briefing',
    mobileStep3: 'Integrazioni',
    mobileStep4: 'Segretaria',
    mobileStep5: 'Prime attività',
    briefingSub1: 'Che cos’è',
    briefingSub2: 'Quando arriva',
    briefingSub3: 'Altre routine',
    assistantSub1: 'Nome',
    assistantSub2: 'Email',
    assistantSub3: 'Carta',
    assistantSub4: 'Il team',
    taskSub1: 'Già fatto',
    taskSub2: 'Inviti',
    taskSub3: 'La tua prima attività',
    continue: 'Continua',
    letsGetStarted: 'Iniziamo',
    back: 'Indietro',
    stepOf: '{{label}} · {{step}} di {{total}}',
    eyebrow: 'Passo {{step}} di {{total}} · {{label}}',
    oneMoment: 'Un attimo…',
    loadingSetup: 'Caricamento della tua configurazione…',
    linkErrorTitle: 'Hmm, quel link non ha funzionato',
    missingToken:
      'A questo link manca il token. Chiedi alla tua segretaria un link nuovo.',
    loadFailed:
      'Qualcosa è andato storto nel caricamento della configurazione.',
    genericError: 'Qualcosa è andato storto. Riprova.',
    allSetTitle: 'Tutto pronto',
    allSetBody:
      'Torna alla tua chat WhatsApp con {{name}} — ti sta aspettando.',
    openWhatsApp: 'Apri WhatsApp',
    privacy: 'Privacy',
    terms: 'Termini',
    openingWhatsAppToast: 'Apertura di WhatsApp — «{{task}}» con {{name}}.',
    oauthMissingScopes:
      'Il tuo account è collegato. L’accesso a {{scopes}} non è stato concesso, quindi la tua segretaria non potrà aiutarti con {{area}} su questo account. Puoi concedere l’accesso in qualsiasi momento ricollegando l’account.',
    oauthMissingAreaSingle: 'quest’area',
    oauthMissingAreaMulti: 'queste aree',
    oauthNoMailboxTitle:
      'Collegato, ma questo account non ha una casella Gmail',
    oauthNoMailbox:
      'Google segnala che Gmail non è attivo per questo account (il suo Workspace non include più Gmail, oppure è un accesso Google associato a un indirizzo non Gmail). La tua segretaria potrà usare calendario e contatti, ma non leggere, cercare o scrivere email da questo account. Se la tua email è altrove, collega anche quell’account.',
    listAnd: 'e',
    oauthAlreadyLinkedOther:
      'Quell’account email è già collegato a un altro account, quindi non è stato possibile aggiungerlo qui. Collegane un altro, oppure contattaci se pensi sia un errore.',
    oauthExpired:
      'Questo link di configurazione è scaduto. Chiedine uno nuovo alla tua segretaria su WhatsApp.',
    oauthInvalidToken:
      'Questo link di configurazione non è più valido. Chiedine uno nuovo alla tua segretaria su WhatsApp.',
    oauthError:
      'Qualcosa è andato storto nel collegare quell’account. Riprova.',
    halfModalTitle: 'Dream vede solo metà della tua settimana',
    halfModalWork:
      'Senza il tuo calendario di lavoro, proporrà orari in cui in realtà non sei libero e si perderà le cose più importanti.',
    halfModalPersonal:
      'Senza il tuo calendario personale, prenoterà sulle tue serate e sui weekend come se fossero liberi.',
    connectWork: 'Collega lavoro',
    connectPersonal: 'Collega personale',
    carryOnAnyway: 'Continua comunque',
    noAccount: {
      title: 'Continuare senza un account?',
      needs:
        '{{name}} ha bisogno di vedere il tuo calendario e la tua email per lavorare al meglio.',
      impact:
        'Non potrà controllare la tua disponibilità e questo potrebbe causare sovrapposizioni nella tua agenda.',
      changeLater:
        'Se sei sicuro, scegli «continua» qui sotto. Puoi cambiare idea in qualsiasi momento.',
      understandContinue: 'Ho capito, continua',
      goBackConnect: 'Torna indietro e collega',
    },
    previewCap: 'Cosa arriva alle',
    previewMorning:
      'Buongiorno{{name}} — ecco la tua giornata. Tre riunioni, due risposte ancora in sospeso.',
    previewFullBriefing: 'Briefing completo per ogni riunione',
    previewEveningRoundUp: 'Riepilogo serale delle cose in sospeso',
    previewOwedReplies: 'Risposte che devi, e che ti devono',
    connect: {
      title: 'Collega i tuoi account',
      ledeWide:
        'Collega email e calendario così {{name}} potrà seguire le tue attività e controllare i conflitti di calendario.',
      ledeNarrow:
        'Collega email e calendario così {{name}} vedrà tutta la tua settimana.',
      ledeExtra:
        'Aggiungi il tuo account personale e quello di lavoro così vedrà tutta la tua settimana.',
      personal: 'Personale',
      personalSub: 'La tua casella di posta e la tua agenda.',
      work: 'Lavoro',
      workSub: 'Dove si trovano la maggior parte delle tue riunioni.',
      connected: 'Collegato',
      notConnected: 'Non collegato',
      connectedAccount: 'Account collegato',
      disconnectAria: 'Scollega {{account}}',
      thisAccount: 'questo account',
      addAnother: 'Aggiungine un altro',
      opening: 'Apertura…',
      openConnectError: 'Impossibile aprire la pagina di collegamento.',
      disconnectError: 'Impossibile scollegare l’account.',
      adminNoteTitle: 'Non riesci a collegare il tuo account di lavoro?',
      adminNoteBody:
        'Se sei stato rimandato indietro senza una schermata di consenso, potrebbe darsi che l’amministratore del tuo workspace debba prima approvare Dream — ecco una guida da inviargli.',
      adminGuideShareTitle:
        'Perché Dream ha bisogno di accedere al tuo account Google',
      sendAdminGuide: 'Invia la guida al tuo amministratore',
      guideLinkCopied: 'Link copiato — incollalo al tuo amministratore',
      viewGuide: 'Vedi la guida',
      dismiss: 'Chiudi',
      connectionDidntFinish: 'Quel collegamento non è andato a buon fine',
      neverSend: 'Non invierà mai un’email dal tuo account.',
      disclaimer: 'Supportiamo account Gmail, Google Workspace e Outlook.',
      noAccountHint: 'Preferisci non collegarne nessuno?',
      carryOnWithout: 'Continua senza un account email',
      chooseTitle: 'Collega un account email',
      chooseLede:
        'Gmail o Outlook. Capisco dall’indirizzo se è di lavoro o personale, e puoi cambiarlo.',
      gmail: 'Gmail',
      outlook: 'Outlook',
      workNeededNote:
        '{{org}} ha bisogno della tua email di lavoro, quindi collega quella.',
      kindAria: 'Lavoro o personale',
      changeKindError: 'Impossibile cambiare il tipo di account. Riprova.',
      kindLabel: 'Che tipo di account è?',
      professional: 'Lavoro',
      professionalSub: 'La tua email e il tuo calendario di lavoro.',
      neededFor: 'Necessario per {{org}}',
      providerLabel: 'Con quale provider?',
      google: 'Google',
      microsoft: 'Microsoft',
      other: 'Altro',
      otherNoteWork:
        '{{org}} richiede un account di lavoro Google o Microsoft. Se la tua email di lavoro è con un altro provider, chiedi al tuo team IT.',
      otherNote:
        'Per ora {{name}} funziona con account Google e Microsoft. Puoi continuare senza e collegarlo più tardi.',
    },
    briefing: {
      whatTitle: 'Svegliati con un passo di vantaggio',
      whatLedeWide:
        'Ogni mattina un solo messaggio con tutto ciò che altrimenti scopriresti troppo tardi.',
      whatLedeNarrow: 'Un messaggio ogni mattina, su WhatsApp.',
      morningLede: 'Buongiorno{{name}} — ecco la tua giornata.',
      line1: 'Volo per Amsterdam, 11:05 — carta d’imbarco allegata',
      line2: 'Tre riunioni, tutte con briefing e foto',
      line3: 'Due risposte ancora in sospeso, bozze pronte',
      line4: 'Giovedì è il compleanno di Angie',
      whatFoot: 'Arriva su WhatsApp, ogni mattina.',
      whenTitle: 'Quando deve arrivare?',
      whenLedeWide:
        'Scegli un orario che ti va bene — puoi cambiarlo quando vuoi.',
      whenLedeNarrow: 'Scegli un orario — potrai cambiarlo più tardi.',
      arrivesAt: 'Arriva alle',
      onWhatsApp: 'Su WhatsApp',
      earlier15: '15 minuti prima',
      later15: '15 minuti dopo',
      deliveryTimeAria: 'Orario di consegna del briefing',
      includeInBriefing: 'Includi nel briefing',
      fullMeetingBriefing: 'Briefing completo delle riunioni',
      alwaysOn: 'Sempre attivo',
      fullMeetingSub:
        'Foto, come vi hanno presentato e come si pronunciano i nomi di tutti.',
      routinesTitle: 'Altre cose che la tua segretaria può gestire',
      routinesLede:
        'Tutte sono attive all’inizio — disattiva ciò che non vuoi.',
      eveningTitle: 'Riepilogo serale delle cose in sospeso',
      eveningSub:
        'Un breve messaggio a fine giornata: cosa è sfuggito, cosa avevi detto di fare e cosa ti aspetta al mattino.',
      owedTitle: 'Monitoraggio delle risposte dovute',
      owedSub:
        'Tiene il conto di chi ti sta aspettando e di chi stai aspettando tu, e ti avvisa prima che diventi imbarazzante.',
      labellingTitle: 'Ordinare ed etichettare la tua casella',
      labellingSub:
        'Etichetta ciò che arriva — ricevute, newsletter, cose che richiedono te — e toglie di mezzo il rumore. Tieni già in ordine la tua casella? Lascialo disattivato.',
    },
    integrations: {
      title: 'Collega Dream a tutto il resto',
      ledeWide:
        '{{name}} può lavorare negli strumenti che già usi, leggendo ciò che c’è e facendo le parti che altrimenti faresti a mano.',
      ledeNarrow: '{{name}} lavora negli strumenti che già usi.',
      ledeExtra: 'Collega ciò che vuoi ora, o torna a farlo più tardi.',
      alreadyConnected: 'Già collegato',
      whatsappRowName: 'WhatsApp',
      whatsappRowMeta: 'Dove tu e {{name}} vi parlate',
      spottedInEmail: 'Trovato nelle tue email',
      everythingElse: 'Tutto il resto',
      addMore: 'Aggiungi altro',
      showFewer: 'Mostra meno',
      showAll: 'Mostra tutti e {{count}}',
      connected: 'Collegato',
      connect: 'Collega',
      comingSoon: 'In arrivo',
      cancel: 'Annulla',
      close: 'Chiudi',
      verifying: 'Verifica in corso…',
      personal: 'Personale',
      work: 'Lavoro',
      connectedAccount: 'Account collegato',
      connectApp: 'Collega {{name}}',
      apiKeyBody: '{{hint}} e {{name}} la verificherà prima di salvarla.',
      apiKeyDefaultHint: 'Incolla la tua chiave API',
      apiKeyPlaceholder: 'Chiave API {{name}}',
      connectError: 'Impossibile collegare. Riprova.',
      apps: {
        slack: {
          sub: 'Messaggi e canali',
          spottedSub:
            'Tiene d’occhio i canali importanti, pubblica aggiornamenti a tuo nome e ti aggiorna su ciò che ti sei perso.',
        },
        hubspot: {
          sub: 'Contatti e trattative',
          spottedSub:
            'Registra chiamate e note, tiene aggiornati trattative e contatti e sollecita i prossimi passi per te.',
        },
        attio: {
          sub: 'Schede CRM',
          spottedSub:
            'Tiene aggiornate le schede e i nuovi contatti dopo ogni chiamata ed email, senza che tu faccia la parte amministrativa.',
        },
        linear: {
          sub: 'Issue e progetti',
          spottedSub:
            'Crea, aggiorna e sollecita le issue così i tuoi progetti vanno avanti mentre sei altrove.',
        },
        notion: {
          sub: 'Pagine, elenchi e database',
          spottedSub:
            'Legge le tue liste di cose da fare condivise, aggiunge e spunta elementi, e crea o aggiorna pagine e database per te.',
        },
        asana: {
          sub: 'Attività e progetti',
          spottedSub:
            'Crea e aggiorna attività dalle tue conversazioni e sollecita ciò che blocca un progetto.',
        },
        todoist: {
          sub: 'La tua lista di cose da fare',
          spottedSub:
            'Aggiunge attività direttamente da email e WhatsApp e le spunta man mano che vengono completate.',
        },
        granola: {
          sub: 'Note delle riunioni',
          spottedSub:
            'Trasforma automaticamente le note delle riunioni in azioni e follow-up dopo ogni chiamata.',
        },
        xero: {
          sub: 'Fatture e spese',
          spottedSub:
            'Sollecita le fatture non pagate, archivia le ricevute e tiene d’occhio le spese senza che tu lo apra.',
        },
        lusha: {
          sub: 'Arricchimento contatti',
          spottedSub:
            'Trova i recapiti delle persone che vuoi raggiungere, proprio quando ti servono.',
          keyHint: 'Incolla la tua chiave API di Lusha',
        },
        devin: {
          sub: 'Attività di ingegneria',
          spottedSub:
            'Affida lavori di ingegneria, li segue fino al completamento e ti avvisa quando hanno bisogno di te.',
          keyHint: 'Incolla la tua chiave API di Devin',
        },
      },
    },
    assistant: {
      nameTitle: 'Conosci la tua segretaria',
      nameLedeWide:
        'Si presenterà con questo nome. Cambialo se preferisci chiamarlo in un altro modo.',
      nameLedeNarrow: 'Cambialo se preferisci chiamarlo in un altro modo.',
      nameLabel: 'Nome della tua segretaria',
      nameRequired: 'Dai un nome alla tua segretaria.',
      emailTitle: '{{name}} ha il suo indirizzo email',
      emailLede:
        'Può parlare con il mondo a tuo nome — e risponderà sempre e solo a te.',
      sigQuote:
        '…Ho inserito tre opzioni per giovedì. Fammi sapere quale ti va bene e la confermo.',
      sigRole: 'Segretaria',
      sigRoleTo: 'Segretaria di {{name}}',
      whenEmail: 'Quando può inviare email?',
      expressPermission: 'Solo con il mio permesso esplicito',
      cardTitle: 'E la sua carta personale',
      cardLede:
        'Per prenotare e comprare a tuo nome. Non spende mai senza il tuo consenso.',
      cardKind: 'Virtuale · Monouso',
      cardholder: 'Titolare',
      expires: 'Scadenza',
      whenSpend: 'Quando può spendere?',
      teamTitle: 'Dietro {{name}} ci sono delle persone',
      teamLedeWide:
        'Alcune cose non possono essere fatte dal software. Quando succede, una persona formata del nostro team se ne occupa — e {{name}} resta il tuo interlocutore.',
      teamLedeNarrow:
        'Quando il software non può farlo, se ne occupa una persona vera. {{name}} resta il tuo interlocutore.',
      whatTheyDo: 'Cosa faranno',
      teamItem1:
        'Telefonare a un ristorante, una clinica o un locale senza sistema di prenotazione',
      teamItem2: 'Districarsi in un sito web che resiste all’automazione',
      teamItem3:
        'Insistere su qualcosa che richiede una persona che continui a chiedere',
      playSample: 'Riproduci chiamata di esempio',
      pauseSample: 'Metti in pausa la chiamata di esempio',
      hearCallIn: 'Ascolta la chiamata in',
      callLanguage: {
        en: 'Inglese',
        de: 'Tedesco',
        fr: 'Francese',
        it: 'Italiano',
        es: 'Spagnolo',
      },
      audioTitle: 'Ascolta una chiamata vera: prenotazione di un tavolo',
    },
    alreadyDone: {
      putToWorkTitle: 'Metti {{name}} al lavoro',
      putToWorkLede:
        'Primo compito: preparare bozze di risposte e solleciti per ciò che aspetta nella tua casella di posta.',
      firstDrafts: 'Le tue prime bozze',
      firstDraftsSub:
        'Pronte in pochi minuti. {{name}} non invia mai — lo fai tu.',
      draftCta: 'Prepara le mie prime risposte',
      hitASnag: '{{name}} ha incontrato un intoppo',
      snagLede:
        'Non sono riuscito a finire le tue prime bozze — ma tranquillo, nessun problema.',
      snagLine1: 'Continuo a preparare bozze man mano che arrivano email',
      snagLine2: 'Niente parte senza di te',
      tryingAgain: 'Nuovo tentativo…',
      tryAgain: 'Riprova',
      alreadyDoneTitle: 'Già fatto',
      emptyLede: 'Tutto in ordine — al momento niente richiedeva una risposta.',
      emptyLine1: 'Preparo bozze man mano che arrivano email',
      emptyLine2: 'Tutto aspetta nella tua cartella bozze',
      readyLede: 'Fatto — le tue bozze sono pronte.',
      readyLine1: 'In attesa nella tua cartella bozze',
      readyLine2: 'Modificale tu stesso, o chiedimi delle modifiche',
      onItTitle: '{{name}} ci sta lavorando',
      now: 'adesso',
      working: 'Al lavoro',
      workingLede:
        'Sto esaminando la tua casella di posta — le tue prime bozze richiedono qualche minuto.',
      workingLine1:
        'Aspetteranno nella tua cartella bozze — niente parte senza di te',
      workingLine2: 'Ti scriverò su WhatsApp appena saranno pronte',
      workingFoot: 'Non serve aspettare qui — puoi continuare.',
    },
    referrals: {
      title: 'Invita i tuoi amici, delega di più',
      lede1: 'Inizia con {{amount}} di crediti al mese, gratis.',
      lede2:
        'Invita un amico: {{amount}} di crediti a testa, per te e per lui.',
      lede1V3:
        'Il tuo primo mese di Dream è gratis: uso illimitato, offerto da noi.',
      lede2V3: 'Invita un amico e ricevete entrambi utilizzo bonus su Dream.',
      invitesNote:
        'Hai {{count}} inviti questo mese, scegli qualcuno che abbia davvero bisogno di una segretaria.',
      yourInviteLink: 'Il tuo link di invito',
      copied: 'Copiato',
      copyLink: 'Copia link',
      copyError: 'Impossibile copiare il tuo link — selezionalo e copialo.',
    },
    tasks: {
      loaderTitle: 'Sto imparando a conoscerti',
      loaderLede:
        'Dammi un attimo con la tua casella di posta e il calendario. Ecco cosa ho colto finora.',
      spline1: 'Leggo il ritmo della tua settimana',
      spline2: 'Capisco le tue abitudini di viaggio',
      spline3: 'Scopro quando preferisci le riunioni',
      spline4: 'Individuo le persone con cui parli di più',
      spline5: 'Imparo quali email contano davvero per te',
      spline6: 'Noto le tue prenotazioni e i tuoi posti abituali',
      spline7: 'Mappo le tue mattine e le tue serate',
      spline8: 'Rilevo abbonamenti e rinnovi',
      title: 'Cosa deve fare {{name}} per primo?',
      lede: 'Scegline una — i dettagli li sistemi in chat.',
      pickOne: 'Scegline una per iniziare',
      chooseAria: 'Scegli una prima attività',
      somethingElse: 'Qualcos’altro',
      somethingElseTagline: 'Puoi chiedere qualsiasi cosa',
      bookRestaurant: 'Prenota un ristorante',
      bookHaircut: 'Prenota un taglio di capelli',
      findFlights: 'Trova voli',
      yourFirstTask: 'la tua prima attività',
      validation: 'Scegline una per iniziare.',
      handoff: 'Apre la tua chat WhatsApp con {{name}}.',
    },
  },
  // Vista pubblica per ospiti di una lista di cose da fare condivisa (vedi en.ts).
  login: {
    title: 'Accedi a Dream',
    lede: 'Inserisci il numero di telefono che usi con Dream e ti invieremo un codice monouso via SMS.',
    phoneLabel: 'Numero di telefono',
    countryLabel: 'Prefisso internazionale',
    countrySearchPlaceholder: 'Cerca paesi',
    countryNoResults: 'Nessun paese corrispondente',
    sendCode: 'Inviami un codice',
    or: 'oppure',
    continueWithGoogle: 'Continua con Google',
    continueWithMicrosoft: 'Continua con Microsoft',
    newHere:
      'Nuovo su Dream? Inizia prima una conversazione con la tua segretaria su WhatsApp.',
    errors: {
      empty: 'Inserisci il tuo numero di telefono.',
      malformed: 'Non sembra un numero di telefono. Usa solo cifre.',
      tooShort:
        'Questo numero è troppo corto per {{selectedCountry}} ({{selectedCode}}).',
      tooLong:
        'Questo numero è troppo lungo per {{selectedCountry}} ({{selectedCode}}).',
      countryMismatch:
        'Questo numero inizia con {{typedCode}} ({{typedCountry}}), ma è selezionato {{selectedCountry}} ({{selectedCode}}). Scegli {{typedCountry}} dal menu o rimuovi il prefisso.',
      invalidForCountry:
        'Non è un numero valido per {{selectedCountry}}. Controllalo e riprova.',
    },
  },
  todoGuest: {
    pageTitle: 'Lista condivisa · Dream',
    banner:
      '<strong>{{inviter}}</strong> ti ha invitato a modificare la lista <strong>{{list}}</strong> con Dream',
    members_one: '{{count}} membro',
    members_other: '{{count}} membri',
    you: '{{name}} (tu)',
    empty: 'Non c’è ancora nulla in questa lista.',
    completedByYou: 'Completate da te',
    task: {
      from: 'da {{name}}',
      fromGuest: 'da {{name}} (ospite)',
      editedBy: 'modificata da {{name}}',
      assignedToYou: 'Tu',
      unassigned: 'Non assegnata',
      complete: 'Segna come completata',
      reopen: 'Segna come non completata',
      notYours:
        'Solo la persona a cui è assegnata questa attività può spuntarla',
    },
    newTask: {
      button: 'Nuova',
      title: 'Nuova attività',
      descriptionLabel: 'Attività',
      descriptionPlaceholder: 'Descrivi la tua attività',
      dueDateLabel: 'Aggiungi scadenza',
      assignLabel: 'Assegna',
      unassigned: 'Non assegnata',
      priorityLabel: 'Aggiungi priorità',
      noPriority: 'Nessuna priorità',
      priority: {
        high: 'Priorità alta',
        medium: 'Priorità media',
        low: 'Priorità bassa',
      },
      submit: 'Aggiungi attività',
      submitting: 'Aggiunta in corso…',
      error: 'Impossibile aggiungere l’attività. Riprova.',
    },
    errors: {
      updateFailed: 'Impossibile aggiornare l’attività. Riprova.',
    },
    verify: {
      titleWhatsApp: 'Trova il tuo codice su WhatsApp',
      titleEmail: 'Trova il tuo codice nella tua email',
      bodyWhatsApp:
        'Per aprire la lista <strong>{{list}}</strong> di <strong>{{inviter}}</strong>, inserisci il codice a 6 cifre che abbiamo appena inviato al <strong>{{destination}}</strong> su WhatsApp.',
      bodyEmail:
        'Per aprire la lista <strong>{{list}}</strong> di <strong>{{inviter}}</strong>, inserisci il codice a 6 cifre che abbiamo appena inviato a <strong>{{destination}}</strong>.',
      codeLabel: 'Codice di verifica',
      submit: 'Apri la lista',
      checking: 'Verifica in corso…',
      sending: 'Invio del codice…',
      resendIn_one: 'Invia di nuovo il codice tra {{count}} secondo',
      resendIn_other: 'Invia di nuovo il codice tra {{count}} secondi',
      resend: 'Invia di nuovo il codice',
      sendCode: 'Inviami un codice',
      errors: {
        invalid: 'Il codice non è corretto. Riprova.',
        invalidWithAttempts_one:
          'Il codice non è corretto. Ti rimane {{count}} tentativo.',
        invalidWithAttempts_other:
          'Il codice non è corretto. Ti rimangono {{count}} tentativi.',
        expired: 'Il codice è scaduto. Richiedine uno nuovo.',
        tooManyAttempts: 'Troppi tentativi errati. Richiedi un nuovo codice.',
        sendFailed:
          'Non siamo riusciti a inviare il codice in questo momento. Riprova.',
        generic: 'Qualcosa è andato storto. Riprova.',
      },
    },
    invalid: {
      title: 'Questo link è scaduto. Dovrai essere invitato di nuovo.',
      body: 'Ottieni la tua segretaria per accedere alle liste e fare molto di più.',
      cta: 'Iscriviti ora su WhatsApp',
    },
    nudge: {
      title: 'Fai ancora di più con la tua Segretaria IA',
      body: 'Ottieni una segretaria di prima classe, supportata da vere segretarie qualificate, pronta a gestire la tua quotidianità.',
      getYourOwnPa: 'Ottieni la tua segretaria',
      phonePrompt:
        'Inizia a chattare con la tua segretaria su WhatsApp — inserisci il tuo numero di telefono',
      phonePlaceholder: 'Il tuo numero di telefono',
      phoneSubmit: 'Continua su WhatsApp',
      phoneInvalid:
        'Inserisci un numero di telefono valido con il prefisso internazionale.',
      outcome: {
        sent: 'Fatto — apri WhatsApp, la tua nuova segretaria ti ha appena scritto.',
        already_on_dream:
          'Questo numero ha già un account Dream. Apri WhatsApp per continuare a chattare con la tua segretaria.',
        already_invited:
          'Hai già iniziato la registrazione — apri WhatsApp per riprendere da dove eri rimasto.',
      },
      error: 'Qualcosa è andato storto. Riprova.',
      later: 'Forse più tardi',
    },
  },
  expenseReview: {
    headingSingle: 'La tua richiesta di rimborso',
    headingMulti: 'Le tue richieste di rimborso',
    subSingle:
      'Non è ancora stata inviata. Scegli “Invia” o chiedi alla tua segretaria quando sei pronto.',
    subMulti:
      'Non sono ancora state inviate. Scegli “Invia” o chiedi alla tua segretaria quando sei pronto.',
    alreadySubmittedSingle: 'Questa spesa è già stata inviata.',
    alreadySubmittedMulti: 'Queste spese sono già state inviate.',
    empty: 'Nessuna spesa in questo controllo.',
    submit: 'Invia',
    submitting: 'Invio…',
    submitAll: 'Invia tutte ({{count}})',
    submitSome: 'Invia {{selected}} di {{total}}',
    close: 'Chiudi',
    notNow: 'Non ora',
    error: 'Impossibile raggiungere Dream. Riprova.',
    include: 'Includi {{vendor}}',
    thisExpense: 'questa spesa',
    unknownVendor: 'Fornitore sconosciuto',
    amountMissing: 'Importo mancante',
    duplicate:
      'Sembra un duplicato di una spesa già registrata (rif. {{ref}}).',
    rows: {
      settledOnCard: '{{amount}} sulla carta',
      inYourAccounts: 'Apri nella tua contabilità',
    },
    paymentMethod: {
      company_card: 'Carta aziendale',
      personal_card: 'Carta personale (rimborso)',
    },
    status: {
      draft: 'Bozza',
      awaiting_info: 'Mancano informazioni',
      awaiting_confirmation: 'Pronta da registrare',
      approved: 'Approvata',
      submitted: 'Registrata',
      failed: 'Registrazione non riuscita',
      discarded: 'Scartata',
    },
    receipts: {
      none: 'Nessuna ricevuta allegata',
      fallbackName: 'Ricevuta {{n}}',
      openInDream: 'Apri Dream per vedere il file',
    },
  },
};

export default it;
